export const lcRelatedArticlesStandard = {
  __typename: 'SectionLearningCenterRelatedArticles',
  title: 'Related Articles',
  articlesCollection: {
    items: [
      {
        sys: {
          id: '2MJQUgY51vgGa7ZvvSv1Tr',
        },
        title: '401(k) deadlines for employers',
        lastModified: '2023-06-28T17:33:47.902Z',
        categories: ['employers'],
        subcategories: ['401k-compliance-and-administration'],
        resourceType: 'Guides',
        resource: {
          __typename: 'LearningCenterGuide',
          slug: '401k-deadlines',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/1oOA7vY4ir5gbIoUTdIuBk/c95a1401c339675f8f46e90ca9e84e71/401_k__deadlines_for_employers_-_blue_2x.png',
          },
        },
      },
      {
        sys: {
          id: '5rNy6d48eMBHyZq8c8wUOz',
        },
        title: '401(k) Rules for Employers: Requirements and Guidelines',
        lastModified: '2023-09-18T18:34:54.945Z',
        categories: ['employers'],
        subcategories: ['starting-a-401k'],
        resourceType: 'Articles',
        resource: {
          __typename: 'LearningCenterArticle',
          slug: '401k-basics-for-employers',
          image: {
            url: 'https://images.ctfassets.net/tj9jxg7kaxby/7l9XJHxgkmUitYKunsZHUY/0c17d1d81ee529c846ce433218a44105/401k-Basics.jpg',
          },
        },
      },
    ],
  },
};
